import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { fetchData } from "../../redux/actions";
import { our_story, contact_us } from '../../redux/selectors';
import { underscoresToHighlights } from '../../utils/parse-text';
import Slider from "react-slick";
import HistoryRoadMap from "./HistoryRoadMap";
import PointsOfInterest from "./PointsOfInterest";
import OurStoryHeroArea from "./OurStoryHeroArea";

const Story = () => {
    const dispatch = useDispatch();
    const data = useSelector(our_story("our_story"));
    const contactUsData = useSelector(contact_us("our_story"));
    
    useEffect(() => {
        if (!data || data.length === 0) {  
            dispatch(fetchData("our_story","pages?path=/company-info/our-story"));
        }
        }, [dispatch, data]);   
    
    const storyContent = data?.our_story?.[0]?.attributes;
    const stories = data?.stories_area;

    const seo_data = useSelector((state) => state?.seo_data?.seo_data) ?? {};

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;    
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 7,
            },
          },
          {
            breakpoint: 1399,
            settings: {
              slidesToShow: 6,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 424,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 359,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
    };
    return (
        <>
            {seo_data && (
                <Helmet>                    
                    <title>{seo_data?.title }</title>   
                    <meta name="description" content={seo_data?.description}  />
                    <meta property="og:title" content={seo_data?.title} />
                    <meta property="og:description" content={seo_data?.description} />                 
                </Helmet>          
            )}
            <section className="hot-deals">            
                <div className="container container-lg">
                    {/* main component */}
                    <div>
                        <OurStoryHeroArea data={data} />
                    </div>
                    {/* component 1 */}
                    <div className="row gy-4">
                        <div className="col-sm-7 p-30">                        
                            <div className="flex-between flex-wrap gap-8">
                                <h2 
                                    className="mb-0 text-blue flex-grow-1"
                                    dangerouslySetInnerHTML={{ __html: underscoresToHighlights(storyContent?.title) }}
                                />
                            </div>                        
                            <div className="row g-12 mt-10">                    
                                <h6
                                    className="mb-0 text-blue"
                                    dangerouslySetInnerHTML={{ __html: underscoresToHighlights(storyContent?.subtitle) }}
                                />                    
                            </div>
                            <div className="h-px w-full bg-medium-electric-blue mt-20 mb-20" />
                            <div className="wysiwyg  pb-6" dangerouslySetInnerHTML={{ __html: storyContent?.description }} />
                            <div>
                                {storyContent?.buttons?.map(button => (
                                    <Link
                                        to={button?.attributes?.link?.en}
                                        className="btn align-items-center mt-30 bg-main-product-50 hover-bg-main-product-50"
                                    >
                                        {button?.attributes?.title}
                                    </Link>
                                ))}
                            </div>
                        </div>
                        <div className="col-sm-5">
                            <img
                                src={storyContent?.image?.files?.original?.url}
                                alt="story"
                            />
                        </div>
                    </div>
                    {/* component 2 */}
                    <div className="row bg-light-grey p-30">
                        <div className="row g-12">                    
                            <h6 className="mb-0 text-blue">     
                                <p>{storyContent?.bullet_points?.[0]?.attributes?.subtitle}</p>
                            </h6>                                          
                        </div>
                        <div className="h-px w-full bg-medium-electric-blue mt-20 mb-20 ml-10" />
                        <div className="blue-disc-unordered-list">
                            <ul className="grid grid-cols-2 gap-x-6 text-dark-md-blue md:grid-cols-3 list-disc list-inside">
                                {storyContent?.bullet_points?.[0]?.attributes?.bullet_point?.map(bullet => (
                                    <li className="text-content text-dark" key={bullet.key}>
                                        {bullet.attributes?.text}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {/* component 3 */}
                    <div className="p-20">
                        {stories?.map(story => (
                            <div className="row gy-4">
                                <div className="col-sm-5">  
                                    <img
                                        src={story.attributes?.image?.files?.original?.url}
                                        alt="story"
                                    />
                                </div>
                                <div className="col-sm-6">  
                                    <div className="row g-12 mt-10">                    
                                        <h6
                                            className="mb-0 text-blue"
                                            dangerouslySetInnerHTML={{ __html: underscoresToHighlights(story?.attributes?.title) }}
                                        />                    
                                    </div>
                                    <div className="mt-30 wysiwyg pb-6" 
                                        dangerouslySetInnerHTML={{ __html:  underscoresToHighlights(story?.attributes?.paragraph) }}
                                    />
                                    <Link
                                        to={story?.attributes?.link}
                                        className="text-blue hover-text-main-600 mt-20"
                                    >
                                        <div>
                                            <b>{story?.attributes?.link_text}</b>
                                            &nbsp; <span className="size-20">&rsaquo;</span> 
                                        </div>    
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* component 4 */}
                    <div lassName="brand p-20">
                        <div className="brand">
                            <div className="container container-lg">
                                <div className="brand-inner bg-light-grey rounded-16">
                                    <div className="section-heading p-20">
                                        <div className="flex-between flex-wrap gap-8">
                                            <h5 className="mb-0">Our Clients</h5>
                                            <div className="flex-align mr-point gap-16"></div>
                                        </div>
                                    </div>
                                    <div className="brand-slider arrow-style-two">
                                        <Slider {...settings}>
                                            {data &&
                                            data?.carousel_items.length > 0 &&
                                            // Create a new array with at least 7 items
                                            Array.from({ length: 7 }, (_, i) => data?.carousel_items[i % data?.carousel_items.length]).map(
                                            (val, index) => (
                                                <div key={index} className="brand-item mb-20">                                                    
                                                    <img
                                                        src={val?.attributes?.image?.files?.small?.url}
                                                        alt="Client"
                                                    />                                                    
                                                </div>
                                            )
                                            )}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* component 5 */}
                    <div className="p-20">
                        <HistoryRoadMap timelineData={data?.journey} title={data?.title}  />
                    </div>
                    {/* component 6 */}
                    <div className="p-20">
                        <h5 className="mb-20">Contact Us</h5>
                        <PointsOfInterest data={contactUsData} />
                    </div>
                </div>
            </section>
        </>
    );
};

export default Story;
